import { CategorySortContainer as SourceCategorySortContainer } from 'SourceComponent/CategorySort/CategorySort.container';

/** @namespace AdvoxBasic/Component/CategorySort/Container/CategorySortContainer */
export class CategorySortContainer extends SourceCategorySortContainer {
    _prepareOptions() {
        const { sortFields } = this.props;

        if (!sortFields) {
            return [];
        }

        const selectOptions = sortFields.reduce((acc, option) => {
            const { id } = option;
            // eslint-disable-next-line fp/no-let
            let cleanId = id;

            if (id && id.indexOf('-') !== -1) {
                cleanId = id.split('-')[0];
            }

            const label = this._getLabel(option);
            const { asc, desc } = label;

            if (asc) {
                acc.push({
                    id: `ASC ${cleanId}`,
                    name: id,
                    value: `ASC ${cleanId}`,
                    label: asc,
                });
            }

            if (desc) {
                acc.push({
                    id: `DESC ${cleanId}`,
                    name: id,
                    value: `DESC ${cleanId}`,
                    label: desc,
                });
            }

            return acc;
        }, []);

        return selectOptions;
    }
}

export default CategorySortContainer;
